// extracted by mini-css-extract-plugin
module.exports = {"reader":"Reader_reader__12Goe","top":"Reader_top__2iXGg","bottom":"Reader_bottom__3s2dQ","left":"Reader_left__204tl"};